import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { ThemeAssetComponent } from '@partners/themes';
import { BaseButtonComponent } from '../base-button/base-button.component';

@Component({
  selector: 'link-button',
  standalone: true,
  imports: [MatButtonModule, MatRippleModule, ThemeAssetComponent],
  template: `
    <button mat-button [disableRipple]="true" (click)="onClick($event)" type="button">
      @if (iconName()){
      <span [class]="'icon icon--' + iconSize()">
        <theme-asset flex="" [size]="iconSize()" [asset]="iconName()" data-ext="svg"></theme-asset>
      </span>
      }
      <span class="link-label">
        <ng-content></ng-content>
      </span>
      @if(decoration === 'arrow' || decoration ==='underline-arrow') {
      <span class="link-arrow">
        <theme-asset flex="" max-width="15px" asset="chevron-left" data-ext="svg"></theme-asset>
      </span>
      }
    </button>
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'button--link'
  },
  exportAs: 'linkButton'
})
export class LinkButtonComponent extends BaseButtonComponent {
  @Input()
  @HostBinding('class')
  decoration: 'underline' | 'arrow' | 'underline-arrow' | 'none' = 'none';

  constructor() {
    super();
  }

  onClick(event: MouseEvent | TouchEvent) {
    event.preventDefault();
    event.stopPropagation();

    this.click.emit({ event: event, context: this.context });
    this.changeDetector.markForCheck();
  }
}
